import React from "react";

export const NAB_LeadTrackingHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={2} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th colSpan={4} className={"bp-report-thead-th"}>Ngày { props?.inputDay }</th>
                <th colSpan={4} className={"bp-report-thead-th"}>MTD</th>
                <th colSpan={4} className={"bp-report-thead-th"}>YTD</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th>Giới thiệu</th>
                <th>Gặp khách hàng</th>
                <th>Tư vấn sâu</th>
                <th>Đóng</th>
                <th>Giới thiệu</th>
                <th>Gặp khách hàng</th>
                <th>Tư vấn sâu</th>
                <th>Đóng</th>
                <th>Giới thiệu</th>
                <th>Gặp khách hàng</th>
                <th>Tư vấn sâu</th>
                <th>Đóng</th>
            </tr>
            </thead>
        </>
    )
}

export default  NAB_LeadTrackingHeader;